<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container" style="  margin-top: 30px !important;">
  <div class="row" *ngIf="appointment">
      <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-enter">
            <div class="tg-widgetdashboard">
                    <div class="tg-dashboardnotification tg-pkgexpirey">
                        <span style="overflow-wrap:break-word">Todays' Appointment</span>
                        <br><br>
                        {{appointment.length}}</div>
                </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-enter" *ngIf="leave">
            <div class="tg-widgetdashboard">
            <div class="tg-dashboardnotification tg-pkgexpirey">
                    <span style="overflow-wrap:break-word">Leaves In {{date.format('MMMM ')}} {{date.format('YYYY ')}} </span>
                    <br><br>
                    {{totalleavecount}}</div>
                    </div>
     </div>
  </div>
  <div class="row" *ngIf="chat">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-enter">
              <div class="tg-widgetdashboard">
                      <div class="tg-dashboardnotification tg-pkgexpirey">
                          <span style="overflow-wrap:break-word">Todays' Chat</span>
                          <br><br>
                          {{totalchat}}</div>
                  </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-enter">
                        <div class="tg-widgetdashboard">
                                <div class="tg-dashboardnotification tg-pkgexpirey">
                                    <span style="overflow-wrap:break-word">Upcomming Chat</span>
                                    <br><br>
                                    {{upcommingchat}}</div>
                            </div>
                  </div>
        </div>
        <div class="row" *ngIf="chat">
                        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-enter">
                              <div class="tg-widgetdashboard">
                                      <div class="tg-dashboardnotification tg-pkgexpirey">
                                          <span style="overflow-wrap:break-word">Total Chat</span>
                                          <br><br>
                                          {{chat.length}}</div>
                                  </div>
                        </div>
                        </div>
 </div>
